import React, {Component} from 'react';
import EnergyList from '../EnergyList/EnergyList';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { Button } from 'rmwc/Button';
import { FormField } from 'rmwc/FormField';
import { Grid, GridCell, GridInner } from 'rmwc/Grid';
import {Icon} from 'rmwc/Icon';
import { Fab } from 'rmwc/Fab';

export default class EnergyForm extends React.Component {
  constructor(props) {
    super(props);
    //this.textInput = React.createRef();
    this.onSubmit = this.onSubmit.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  onSubmit(event) {
    const newItemValue = this.input.value;
    const newVoltage = this.voltage.value;
    const newPower = this.power.value;
    const newHours = this.hours.value;
    if(newItemValue && newVoltage) {
      this.props.addItem({newItemValue, newVoltage, newPower, newHours});
      this.input.value = '';
      this.voltage.value = '';
      this.power.value = '';
      this.hours.value = '';
    }
    event.preventDefault();
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      console.log('enter press here');
      const newItemValue = this.input.value;
      const newVoltage = this.voltage.value;
      const newPower = this.power.value;
      const newHours = this.hours.value;
      if(newItemValue && newVoltage) {
        this.props.addItem({newItemValue, newVoltage, newPower, newHours});
        this.input.value = '';
        this.voltage.value = '';
        this.power.value = '';
        this.hours.value = '';
      }
      event.preventDefault();
    }
  }

  render() {
    return(
      <div style={{padding: '0.5 2rem 1rem 1rem'}}>
        <FormField onKeyPress={this.handleKeyPress}>
          <Grid>
          <GridCell span="3"><TextField
            autoFocus
            type="text"
            ref={node => this.input = node}
            label="Name of device"
            name="userDevice"
            withLeadingIcon="edit"
          />
        </GridCell>

        <GridCell span="3">
          <TextField
            type="number"
            label="Voltage (V)"
            name="volt"
            withLeadingIcon="flash_on"
            ref={node => this.voltage = node}
          />
        </GridCell>

        <GridCell span="3">
          <TextField
            type="number"
            label="Power rating (W)"
            name="power"
            withLeadingIcon="power"
            ref={node => this.power = node}
          />
        </GridCell>

        <GridCell span="2">
          <TextField
            type="number"
            label="Hours (h)"
            name="hoursUsed"
            withLeadingIcon="access_time"
            ref={node => this.hours = node}
          />
        </GridCell>

        <GridCell span="1">
          <Fab onClick={this.onSubmit}>add</Fab>
        </GridCell>
        </Grid>

          </FormField>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnergyForm/EnergyForm.js